(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pixure-advice-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pixure-advice-player')) {
    customElements.define('pixure-advice-player', class extends HTMLElement {
      connectedCallback() {
        const button = this.querySelector('button');
        if (!button || this.dataset.initialized) return;
        this.dataset.initialized = 'true';
        button.hidden = false;
        button.addEventListener('click', () => {
          const frame = document.createElement('iframe');
          frame.title = this.dataset.videoTitle;
          frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
          frame.allowFullscreen = true;
          frame.referrerPolicy = 'strict-origin-when-cross-origin';
          frame.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(this.dataset.videoId) + '?autoplay=1&rel=0&playsinline=1';
          this.replaceChildren(frame);
          frame.focus();
        }, { once: true });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pixure-gallery-controls"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pixure-gallery-controls')) {
    customElements.define('pixure-gallery-controls', class extends HTMLElement {
      connectedCallback() {
        this.gallery = this.closest('product-media');
        this.previous = this.querySelector('[data-gallery-previous]');
        this.next = this.querySelector('[data-gallery-next]');
        this.position = this.querySelector('.pixure-gallery-position');
        if (!this.gallery || !this.previous) return;
        this.events?.abort();
        this.events = new AbortController();
        const move = (direction) => {
          const slider = this.gallery.mainMediaSwiper;
          if (!slider || slider.destroyed) return;
          const index = Math.max(0, Math.min(slider.slides.length - 1, slider.activeIndex + direction));
          slider.slideTo(index);
          this.gallery.updateThumbnailVariant(slider.slides[index]);
          this.update();
        };
        this.previous.addEventListener('click', () => move(-1), { signal: this.events.signal });
        this.next.addEventListener('click', () => move(1), { signal: this.events.signal });
        this.observer?.disconnect();
        this.observer = new MutationObserver(() => this.update());
        const main = this.gallery.querySelector('.main-media');
        if (main) this.observer.observe(main, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
        this.update();
      }
      update() {
        const slider = this.gallery.mainMediaSwiper;
        if (!slider || slider.destroyed) return;
        this.hidden = slider.slides.length < 2;
        this.previous.disabled = slider.activeIndex === 0;
        this.next.disabled = slider.activeIndex >= slider.slides.length - 1;
        this.position.textContent = (slider.activeIndex + 1) + ' / ' + slider.slides.length;
      }
      disconnectedCallback() {
        this.events?.abort();
        this.observer?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pixure-gallery-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pixure-gallery-player')) {
    customElements.define('pixure-gallery-player', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.button = this.querySelector('button');
        this.button.addEventListener('click', () => {
          if (this.querySelector('iframe')) return;
          const frame = document.createElement('iframe');
          frame.title = this.dataset.videoTitle;
          frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
          frame.allowFullscreen = true;
          frame.referrerPolicy = 'strict-origin-when-cross-origin';
          frame.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(this.dataset.videoId) + '?autoplay=1&rel=0&playsinline=1&hl=' + encodeURIComponent(this.dataset.language);
          this.button.hidden = true;
          this.append(frame);
          frame.focus();
        });
        const slide = this.closest('.swiper-slide');
        this.observer = new MutationObserver(() => {
          if (!slide.classList.contains('swiper-slide-active')) {
            this.querySelector('iframe')?.remove();
            this.button.hidden = false;
          }
        });
        this.observer.observe(slide, { attributes: true, attributeFilter: ['class'] });
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.initialized = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
